import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Title } from 'smartsuite-ui';
import { getLegendFormatter } from '../../widgets/utils/dataFormatUtils';
import { getThresholdsWithValues } from '../../utils/configurationAndValidationUtils';
import {
    mergeFilterValues,
    buildWidgetMetricRequests,
} from '../../utils/metricRequestUtils';
import { useLabelContext } from '../../../shared/hooks/labelContext';
import DashboardContext from '../../../shared/hooks/dashboardContext';
import { getChartRenderProps } from '../../dashboardUtils';

function getWidgetClass({ hasChart = true, key }) {
    let className = 'widget';

    if (hasChart) {
        className += ' widget--with-chart';
    }

    if (key === 'airportStatusMap') {
        className += ' widget--airport-status-map';
    }

    return className;
}

function getWidgetStyles(widgetHeight, widgetWidth) {
    return {
        minWidth: widgetWidth,
        height: widgetHeight,
    };
}

export default function WidgetPrintView(props) {
    const { dashboardLabels } = useLabelContext();
    const { thresholdValues } = useContext(DashboardContext);

    const legendFormatter = getLegendFormatter(
        props.widgetConfiguration.friendlyLegendLabels,
        props.friendlyColumnLabels
    );

    const className = getWidgetClass(props.widgetConfiguration.configuration);

    const thresholdsWithValues = getThresholdsWithValues(
        props.widgetConfiguration.thresholds,
        thresholdValues,
        mergeFilterValues(
            props.defaultFilterValues,
            props.widgetConfiguration.filterValues
        )
    );

    return (
        <div
            className={className}
            style={getWidgetStyles(props.widgetHeight, props.widgetWidth)}
        >
            {props.widgetConfiguration.title && (
                <div
                    className="widget__header"
                    style={props.widgetConfiguration.headerStyles}
                >
                    <Title cssClassModifiers={['size-small']}>
                        {props.widgetConfiguration.title}
                    </Title>
                </div>
            )}
            <div
                className="widget-body"
                style={props.widgetConfiguration.printStyles}
            >
                {props.widgetConfiguration.configuration.render(
                    getChartRenderProps(
                        props.widgetConfiguration,
                        buildWidgetMetricRequests(
                            props.widgetConfiguration,
                            props.defaultTimeAndPrecision,
                            props.defaultFilterValues,
                            props.defaultWhereClauses,
                            props.defaultRecordLimit,
                            false
                        ),
                        props.metrics,
                        thresholdsWithValues,
                        legendFormatter,
                        dashboardLabels
                    )
                )}
            </div>
        </div>
    );
}
/* eslint-enable complexity */

WidgetPrintView.propTypes = {
    defaultTimeAndPrecision: PropTypes.instanceOf(Object).isRequired,
    defaultFilterValues: PropTypes.instanceOf(Object).isRequired,
    defaultWhereClauses: PropTypes.instanceOf(Array).isRequired,
    defaultRecordLimit: PropTypes.instanceOf(Object).isRequired,
    friendlyColumnLabels: PropTypes.instanceOf(Object).isRequired,
    metrics: PropTypes.instanceOf(Array).isRequired,
    widgetConfiguration: PropTypes.instanceOf(Object).isRequired,
    widgetHeight: PropTypes.string.isRequired,
    widgetWidth: PropTypes.string.isRequired,
};
